const HTML5Logo = ({ width = 75, height = 75 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 0 256 361"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1342_2093)">
          <path
            d="M255.555 70.7656L232.314 331.126L127.844 360.088L23.6623 331.166L0.445312 70.7656H255.555Z"
            fill="#E44D26"
          />
          <path
            d="M128 337.95L212.417 314.547L232.277 92.0566H128V337.95Z"
            fill="#F16529"
          />
          <path
            d="M82.82 155.932H128V123.995H47.917L48.681 132.563L56.531 220.573H128V188.636H85.739L82.82 155.932ZM90.018 236.542H57.958L62.432 286.688L127.853 304.848L128 304.808V271.58L127.86 271.617L92.292 262.013L90.018 236.542Z"
            fill="#EBEBEB"
          />
          <path
            d="M24.1797 0H40.4097V16.035H55.2567V0H71.4877V48.558H55.2577V32.298H40.4107V48.558H24.1807L24.1797 0ZM92.8297 16.103H78.5437V0H123.358V16.103H109.063V48.558H92.8327V16.103H92.8297ZM130.47 0H147.393L157.803 17.062L168.203 0H185.133V48.558H168.969V24.49L157.803 41.755H157.523L146.35 24.49V48.558H130.47V0ZM193.21 0H209.445V32.508H232.269V48.558H193.209L193.21 0Z"
            fill="black"
          />
          <path
            d="M127.89 220.573H167.217L163.509 261.993L127.889 271.607V304.833L193.362 286.688L193.842 281.292L201.348 197.212L202.127 188.636H127.89V220.573ZM127.89 155.854V155.932H205.033L205.673 148.754L207.129 132.563L207.892 123.995H127.89V155.854Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_1342_2093">
            <rect width="256" height="361" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };
  
  export default HTML5Logo;
  